import makeCrud from '@/store/site/localization/crud'

// Başarı Hikayeleri (Referanslar) — düz CRUD (çeviri yok).
export default makeCrud('module_success_story')
